import { render } from "./Mask.vue?vue&type=template&id=eb0af25e&scoped=true"
const script = {}

import "./Mask.vue?vue&type=style&index=0&id=eb0af25e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0af25e"]])

export default __exports__